// extracted by mini-css-extract-plugin
export default {"contactos":"Contactos_contactos__5eSiL","mapa":"Contactos_mapa__zsj3G","contactForm":"Contactos_contactForm__sD3Hh"};